import { TermsOfServiceUrl } from './terms-of-service-url';
import { TermsOfServiceVersion } from './terms-of-service-version';

interface Params {
  version: TermsOfServiceVersion;
  url: TermsOfServiceUrl;
}

export class TermsOfServiceAggregate {
  readonly version: TermsOfServiceVersion;
  readonly url: TermsOfServiceUrl;
  constructor(private readonly params?: Params) {
    if (params) {
      this.version = params.version;
      this.url = params.url;
    } else {
      this.version = new TermsOfServiceVersion();
      this.url = new TermsOfServiceUrl('https://www.toretanow.app');
    }
  }
}
